import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { ActivatedRoute, Router } from "@angular/router";
import { CustomerService } from "../../../../modules/customer/customer.service";
import { locale as italian } from "../../../../i18n/it";
import { CommissionService } from "../../../../auth/service/commission.service";
import moment from "moment";
import { ICommissionList } from "../../../../auth/models/commission-interface";
import { IRound } from "../../../../auth/models/round-interface";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { ProductsCommissionsService } from "app/modules/products/products-commissions.service";
import { IProductCommissionList } from "app/modules/products/models/prodcuts-commissions";
import { ICustomer } from "../../../../modules/customer/customer.interface";

@Component({
  selector: "app-commission-list",
  templateUrl: "./commission-list.component.html",
  styleUrls: ["./commission-list.component.scss"]
})
export class CommissionListComponent implements OnInit {
  public contentHeader: IContentHeader;
  public searchKey: string = "";
  public tableLimit: number = 10;
  public commissions: Array<ICommissionList | IProductCommissionList> = [];
  public filterCommissions: Array<ICommissionList | IProductCommissionList> = [];
  public filter_has_order: number = 0;
  public filter_detachment: number = 0;
  public filter_customer: number = 0;
  public customers_list: Array<ICustomer> = [];
  public todayDate: moment.Moment = moment();
  public filter_status_commission: number = 0; //Default status 0 to show opened commissions
  public filter_status_round: number = -1;
  public filter_type_order: number = -1;
  public filterYear: number = moment().year();
  public yearsList: number[] = [];
  public filterMonth: number = 0;
  public monthsList = moment.months();

  constructor(
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    public _userService: UserService,
    public _commissionService: CommissionService,
    private router: Router,
    private _customerService: CustomerService,
    private activatedRoute: ActivatedRoute,
    private _productsCommissionsService: ProductsCommissionsService
  ) {
    this._utilService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: italian.data.MENU.COMMISSION,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/"
          },
          {
            name: italian.data.MENU.ECONOMICS_DATA,
            isLink: false
          },
          {
            name: italian.data.MENU.COMMISSION,
            isLink: false
          }
        ]
      }
    };

    for (let year = 2023; year <= moment().year() + 2; year++) {
      this.yearsList.push(year);
    }

    this.activatedRoute.queryParams.subscribe((params) => {
      const searchKey = params.search;
      const client = params.client;
      const order = params.order;
      const detachment = params.detachment;
      const statusRound = params.status_round;
      const statusCommission = params.status_commission;
      const typeOrder = params.type_order;
      const expireInMonth = params.expire_in_month;

      if (!!searchKey && searchKey != 0) {
        this.searchKey = searchKey;
      }
      if (!!client && Number(client) > 0) {
        this.filter_customer = Number(client);
      }
      if (!!order && Number(order) > 0) {
        this.filter_has_order = Number(order);
      }
      if (!!detachment && Number(detachment) > 0) {
        this.filter_detachment = Number(detachment);
      }
      if (!!statusRound && Number(statusRound) >= 0) {
        this.filter_status_round = Number(statusRound);
      }
      if (!!statusCommission && Number(statusCommission) >= 0) {
        this.filter_status_commission = Number(statusCommission);
      }
      if (!!typeOrder && Number(typeOrder) >= 0) {
        this.filter_type_order = Number(typeOrder);
      }
      if (!!expireInMonth && Number(expireInMonth) >= 0) {
        this.filterMonth = Number(expireInMonth);
      }
    });
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_menu_commission")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.customers_list = await this._customerService.getCustomers();
    this.customers_list = this.customers_list.sort((a, b) => (a.name > b.name ? 1 : -1));
    await this.loadCommissions();
  }

  async loadCommissions() {
    this._utilService.showLoading();
    this.commissions = await this._commissionService.getCommissions(this.filterYear);
    if (this._utilService.moduleIsActive("products")) {
      const productsCommissions: IProductCommissionList[] = await this._productsCommissionsService.getCommissions(this.filterYear);
      if (productsCommissions && productsCommissions.length > 0) {
        this.commissions = this.commissions.concat(productsCommissions);
      }
    }
    this.commissions = this.commissions.sort((a, b) => (b.protocol > a.protocol ? 1 : -1));

    this.commissions.map((commission: ICommissionList) => {
      commission.last_order = {
        from: null,
        to: null,
        capacity: null,
        file_url: null,
        residue: null,
        has_order: null,
        closed_date: null,
        label: null,
        status: null,
        status_color: null,
        employees_names: null,
        products_names: null,
        isTimeMaterial: null,
        isProductCommission: null,
        empty: false
      };
      //Sort for have order descending
      commission.orders = commission.orders.sort((a, b) => (a.id < b.id ? 1 : -1));
      if (commission.orders && commission.orders.length > 0) {
        /*In the list we have to show the last order, if there is an active order it will be that one the last,
         * if not we check a pending order, and if we don't have a pending order we show the last expired order*/
        let activeOrder: any;
        if (commission.orders.length === 1) {
          //If is just one element with take that one
          activeOrder = commission.orders[0];
        } else {
          /*First we give a status for taking the order then with the find method
           * From the back-end the status is only 0 or 1
           * 0 means open order
           * 1 mean closed order
           * Here we set status_date
           * 0 Pending, 1 Active, 2 Expired, 3 closed */
          commission.orders.map((el: IRound) => {
            if (moment(el.from) > this.todayDate && !el.closed) {
              el.status_date = 0; //Pending
            }
            if (moment(el.from) <= this.todayDate && moment(el.to) > this.todayDate && !el.closed) {
              el.status_date = 1; //Active
            }
            if (moment(el.from) < this.todayDate && moment(el.to) < this.todayDate && !el.closed) {
              el.status_date = 2; //Expired
            }
            if (el.closed) {
              el.status_date = 3; //Closed
              el.closed_date = el.closed_date || null;
            }
            //Cerco se ce un round in partenza oltre quello attivo
            const oneToStart = commission.orders.find((order) => order.status_date === 0 && el.id !== order.id && (!order.detachment_type || order.detachment_type === "distacco"));
            if (oneToStart) {
              el.oneRoundToStart = {
                from: moment(oneToStart.from).format("DD/MM/YYYY"),
                to: moment(oneToStart.to).format("DD/MM/YYYY")
              };
            }
          });
          //Check if we have an active order
          activeOrder = commission.orders.find((order) => order.status_date === 1 && (!order.detachment_type || order.detachment_type === "distacco"));
          if (!activeOrder) {
            //Check if we have a pending order
            activeOrder = commission.orders.find((order) => order.status_date === 0 && (!order.detachment_type || order.detachment_type === "distacco"));
            if (!activeOrder) {
              //Check if we have an expired order (in the case the find will it the last expired order because initially we sorted the orders descending)
              activeOrder = commission.orders.find((order) => order.status_date === 2 && (!order.detachment_type || order.detachment_type === "distacco"));
            }
            if (!activeOrder) {
              activeOrder = commission.orders.find((order) => order.status_date === 3 && (!order.detachment_type || order.detachment_type === "distacco"));
            }
          }
        }

        if (!!activeOrder?.from) {
          commission.last_order.from = activeOrder.from;
        }

        commission.last_order.isTimeMaterial = (activeOrder.detail_time_material && activeOrder.detail_time_material.length > 0);

        if (activeOrder.products && activeOrder.products.length > 0) {
          commission.last_order.isProductCommission = true;
        }
        if (
          (!activeOrder.detail_time_material || activeOrder.detail_time_material.length < 1) &&
          (!activeOrder.detail_task || activeOrder.detail_task.length < 1) &&
          (!activeOrder.products || activeOrder.products.length < 1)
        ) {
          commission.last_order.empty = true;
        }

        if (!!activeOrder?.to) {
          commission.last_order.to = activeOrder.to;
        }
        if (!!activeOrder?.capacity) {
          commission.last_order.capacity = activeOrder.capacity;
        }
        if (!!activeOrder?.residue) {
          commission.last_order.residue = activeOrder.residue;
        }

        if (!!activeOrder.file_url) {
          commission.last_order.file_url = activeOrder.file_url;
        }
        if (!!activeOrder?.from && !!activeOrder?.to) {
          /*legend status_date order
           * NOT_STARTED 0 It will be possible to change everything
           * STARTED && ACTIVATED 1 It will be possible to change only end_date and description
           * EXPIRED 2 There is no edit if the order/order is expired --> REMOVED
           * CLOSED 3*/
          if (activeOrder.closed) {
            commission.last_order.label = "CLOSE_MASCULIN";
            commission.last_order.status = 3; //CLOSED
            commission.last_order.status_color = "danger";
            commission.last_order.closed_date = activeOrder.closed_date;
          } else {
            if (moment(activeOrder.to) < this.todayDate) {
              commission.last_order.label = "EXPIRED";
              commission.last_order.status = 4; //STARTED && ACTIVATED
              commission.last_order.status_color = "danger";
            } else if (moment(activeOrder.from) > this.todayDate) {
              commission.last_order.label = "NOT_STARTED"; //NOT_STARTED
              commission.last_order.status = 0; //NOT_STARTED
              commission.last_order.status_color = "warning";
            } else if (moment(activeOrder.from) <= this.todayDate && moment(activeOrder.to) > this.todayDate) {
              commission.last_order.label = "ACTIVATED_MASCULIN";
              commission.last_order.status = 1; //STARTED && ACTIVATED
              commission.last_order.status_color = "success";
            } else if (activeOrder.oneRoundToStart) {
              commission.last_order.label = "RENOVATED";
              commission.last_order.status = 4; //RENOVATED
              commission.last_order.status_color = "info";
              commission.last_order.nextRound = {
                from: activeOrder.oneRoundToStart.from,
                to: activeOrder.oneRoundToStart.to
              };
            }

            if (commission.orders.find((r: any) => r.id > activeOrder.id)) {
              commission.last_order.label = "RENOVATED";
              commission.last_order.status = 4; //RENOVATED
              commission.last_order.status_color = "info";
            }
          }
        }
        if (activeOrder && !!activeOrder.employees && activeOrder.employees.length > 0) {
          commission.last_order.employees_names = [];
          activeOrder.employees.map((employee: any) => {
            commission.last_order.employees_names.push(employee.complete_name);
          });
        }
        if (activeOrder && !!activeOrder.products && activeOrder.products.length > 0) {
          commission.last_order.products_names = [];
          activeOrder.products.map((product: any) => {
            commission.last_order.products_names.push(product.name);
          });
        }
      }
    });

    this.searchCommission();

    this._utilService.hideLoading();
  }

  searchCommission() {
    const key: string = this.searchKey.trim().toLowerCase();
    let filterCommissions: Array<ICommissionList | IProductCommissionList> = this.commissions;
    if (key.length > 0) {
      filterCommissions = filterCommissions.filter(
        (item: ICommissionList) =>
          item.complete_name?.toLowerCase().trim().includes(key) ||
          item.last_order?.capacity?.toString().includes(key) ||
          item.last_order?.residue?.toString().includes(key) ||
          item.last_order?.employees_names?.join(",").includes(key) ||
          item?.protocol?.toLowerCase().includes(key)
      );
    }
    if (this.filter_customer > 0) {
      filterCommissions = filterCommissions.filter((item: ICommissionList) => Number(item.client_id) === Number(this.filter_customer));
    }
    if (this.filter_has_order > 0) {
      if (this.filter_has_order === 1) {
        filterCommissions = filterCommissions.filter((item: ICommissionList) => !!item.last_order?.file_url);
      } else if (this.filter_has_order === 2) {
        filterCommissions = filterCommissions.filter((item: ICommissionList) => !item.last_order?.file_url);
      }
    }
    if (this.filter_detachment === 1) {
      filterCommissions = filterCommissions.filter((item: ICommissionList) => item.detachment);
    }
    if (this.filter_detachment === 2) {
      filterCommissions = filterCommissions.filter((item: ICommissionList) => !item.detachment);
    }
    if (this.filter_status_round > -1) {
      filterCommissions = filterCommissions.filter((item: ICommissionList) => item.last_order?.status == this.filter_status_round);
    }
    if (this.filter_status_commission > -1) {
      filterCommissions = filterCommissions.filter((item: ICommissionList) => item?.status == this.filter_status_commission);
    }

    if (this.filter_type_order > -1) {
      if (this.filter_type_order === 0) {
        filterCommissions = filterCommissions.filter((item: ICommissionList) => !!item.last_order.from && !!item.last_order.to && !item.last_order.empty && item.last_order.isTimeMaterial && !item.last_order.isProductCommission);
      } else if (this.filter_type_order === 1) {
        filterCommissions = filterCommissions.filter((item: ICommissionList) => !!item.last_order.from && !!item.last_order.to && !item.last_order.empty && !item.last_order.isTimeMaterial && !item.last_order.isProductCommission);
      } else if (this.filter_type_order === 2) {
        filterCommissions = filterCommissions.filter((item: ICommissionList) => !item.last_order.empty && item.last_order.isProductCommission);
      }
    }

    if (this.filterMonth > 0) {
      const my: string = `${this.filterMonth}-${this.filterYear}`;
      // filterCommissions = filterCommissions.filter((item: ICommissionList) => moment(item.last_order.closed_date).format('M-YYYY') == my || moment(item.last_order.to).format('M-YYYY') == my);
      filterCommissions = filterCommissions.filter((item: ICommissionList) => {
        const currentOrder = item.orders.sort((a, b) => a.id < b.id ? 1 : -1)[0];
        return (currentOrder.closed_date && moment(currentOrder.closed_date).format("M-YYYY") == my) || moment(currentOrder.to).format("M-YYYY") == my;
      });
    }

    this.filterCommissions = filterCommissions;
  }

  changeQueryParams() {
    const url = new URL(window.location.href);

    if (!!this.searchKey && this.searchKey.length >= 3) {
      url.searchParams.set("search", String(this.searchKey));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("search");
      history.pushState({}, "", url);
    }

    if (!!this.filter_customer && Number(this.filter_customer) > 0) {
      url.searchParams.set("client", String(this.filter_customer));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("client");
      history.pushState({}, "", url);
    }

    if (!!this.filter_has_order && this.filter_has_order > 0) {
      url.searchParams.set("order", String(this.filter_has_order));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("order");
      history.pushState({}, "", url);
    }
    if (!!this.filter_detachment && this.filter_detachment > 0) {
      url.searchParams.set("detachment", String(this.filter_detachment));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("detachment");
      history.pushState({}, "", url);
    }

    if (this.filter_status_round > -1) {
      url.searchParams.set("status_round", String(this.filter_status_round));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("status_round");
      history.pushState({}, "", url);
    }

    if (this.filter_status_commission > -1) {
      url.searchParams.set("status_commission", String(this.filter_status_commission));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("status_commission");
      history.pushState({}, "", url);
    }

    if (this.filter_type_order > -1) {
      url.searchParams.set("type_order", String(this.filter_type_order));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("type_order");
      history.pushState({}, "", url);
    }

    if (this.filterMonth > -1) {
      url.searchParams.set("expire_in_month", String(this.filterMonth));
      history.pushState({}, "", url);
    } else {
      url.searchParams.delete("expire_in_month");
      history.pushState({}, "", url);
    }
  }

  async deleteCommission(commission: ICommissionList) {
    if (!this._authenticationService.hasCapability("delete_commission")) {
      window.history.back();
      return false;
    }
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += ` ${commission?.complete_name}`;

    await this._utilService
      .showSWALDeleteConfirmation({ text: deleteText })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          if (!commission.last_order.isProductCommission) {
            await this._commissionService
              .deleteCommission(commission.id)
              .then(async () => {
                await this.loadCommissions();
                this._utilService.hideLoading();
                await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_COMMISSION" });
              })
              .catch(async (err) => {
                this._utilService.hideLoading();
                if (err == "This order has one or more reports.") {
                  await this._utilService.showSWALError({ text: "ERROR_DELETE_COMMISSION_ROUND_TO_MANY_REPORTS" });
                } else {
                  await this._utilService.showSWALError({ text: "ERROR_DELETE_COMMISSION" });
                }
              });
          }
          if (commission.last_order.isProductCommission && this._utilService.moduleIsActive("products")) {
            await this._productsCommissionsService
              .deleteCommission(commission.id)
              .then(async () => {
                await this.loadCommissions();
                this._utilService.hideLoading();
                await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_COMMISSION" });
              })
              .catch(async (err) => {
                this._utilService.hideLoading();

                if (err == "This order has one or more reports.") {
                  await this._utilService.showSWALError({ text: "ERROR_DELETE_COMMISSION_ROUND_TO_MANY_REPORTS" });
                } else {
                  await this._utilService.showSWALError({ text: "ERROR_DELETE_COMMISSION" });
                }
              });
          }
        } else if (result.isDismissed) {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT"
          });
        }
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_DELETE_COMMISSION" });
      });
  }
}
